import { localization } from '~/i18n';
import { enqueueSnackbar } from '~/utils/notifications';

export function notifyReferenceRowRefused(): void {
    enqueueSnackbar(localization.t('replanning.referenceRow.refused'), {
        variant: 'warning',
    });
}
